import Icons from "./icons"
import Fonts from "./fonts"
import Images from "./images"

const AppAssets = {
  Icons,
  Images,
  Fonts,
}

export default AppAssets
